import React from "react";
export default React.memo(function Input(props) {
  return (
    <input
      {...props}
      className={`w-full h-10 px-3 border border-slate-300 rounded-lg bg-white outline-none focus:ring-2 focus:ring-brand-200 ${props.className || ""}`}
    />
  );
});
